import styled, {css} from "styled-components";
import { Button as MuiButton, MenuItem as MuiMenuItem } from "@material-ui/core";

export const SelectWrapper = styled.div`
	position: relative;
	display: inline-block;
	margin-left: ${props => props.theme.widthRatio * 7}px;
`;

export const Button = styled(MuiButton)`
	display: flex;
	justify-content: space-between;
  min-width: ${props => props.theme.widthRatio * 55}px;
	min-height: ${props => props.theme.heightRatio * 40}px;
	padding: 0 0 0 ${props => props.theme.widthRatio * 5}px;
	font: ${props => props.theme.widthRatio * 21}px/${props => props.theme.heightRatio * 28}px SFProRounded-Regular;
	background: ${props => props.theme.palette.primary[850]};
	border: 1px solid rgba(0, 0, 0, 0);
	
	${props => props.theme.name === 'dark' && css`
		${props => !!props.opened && css`
			border-color: ${props => props.theme.palette.secondary.main};
		`}
	`}
	
	${props => props.theme.name === 'light' && css`
		background-color: #DEDEDE !important;
	`}
	
	.MuiButton-label {
		color: ${props => props.theme.palette.third[100]};
	}
	
	span.label {
		width: 100%;
	}
	
	svg {
		width: ${props => props.theme.widthRatio * 24}px;
		height: ${props => props.theme.widthRatio * 24}px;
	}
`;

export const MenuItem = styled(MuiMenuItem)`
	display: flex;
	justify-content: center;
	min-height: unset;
	color: ${props => props.theme.palette.third[100]};
	font: ${props => props.theme.widthRatio * 21}px/${props => props.theme.heightRatio * 28}px SFProRounded-Regular;
	padding: ${props => props.theme.widthRatio * 3}px ${props => props.theme.widthRatio * 10}px;
	
	&.Mui-selected {
		background-color: ${props => props.theme.palette.third[10]};
	}
`;
